import React from "react";
import GlitchText from "./GlitchText";

export default function FooterInfo() {
  return (
    <>
      <div className="footer-center-text">
      </div>
      <div className="footer-left-links">
        
      </div>
      <div className="footer-right-links">
        <GlitchText text="_COMPLIANCE DOCS" />
      </div>
    </>
  );
}
